export default __webpack_public_path__ + "static/media/first-page-image.922e9c7e.jpg";